/**
* First we will load all of this project's JavaScript dependencies which
* includes Vue and other libraries. It is a great starting point when
* building robust, powerful web applications using Vue and Laravel.
*/

require('./bootstrap');

window.Vue = require('vue');
Vue.config.performance = true;
import store from './store'
import { mapGetters, mapActions } from 'vuex'
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});
/**
* Next, we will create a fresh Vue application instance and attach it to
* the page. Then, you may begin adding components to this application
* or customize the JavaScript scaffolding to fit your unique needs.
*/
import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
  locale: 'en-US',
  locales: { 'en-US': require('vue-timeago/locales/en-US.json') }
})

import vueSignature from "vue-signature"
Vue.use(vueSignature);
createDpiTestElements();
import VeeValidate, { Validator } from 'vee-validate'
import validationDynamicLocale from "./dynamic-locale";
import queryString from 'query-string';
import _ from 'lodash';
import fancybox from '@fancyapps/fancybox';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/images/empty.png',
  loading: '/images/loading.gif',
  attempt: 1
})
import VueDirectiveTooltip from 'vue-directive-tooltip'
Vue.use(VueDirectiveTooltip);
import sweetalert from 'sweetalert';

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm:ss');
  }
});

Vue.filter('formatDate1', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY');
  } else {
    return '-';
  }
});

Vue.filter('formatDate2', function (value) {
  if (value) {
    var lang = document.querySelector('body').getAttribute('data-lang');
    moment.locale(lang);
    console.log(String(value), moment(String(value)));
    return moment(String(value)).format('MMM DD, YYYY');
  } else {
    return '-';
  }
});

Vue.filter('formatDate3', function (value) {
  if (value) {
    var lang = document.querySelector('body').getAttribute('data-lang');
    moment.locale(lang);
    return moment(String(value), 'DD-MM-YYYY').format('MMM DD, YYYY');
  } else {
    return '-';
  }
});


Validator.localize({ validationDynamicLocale: validationDynamicLocale });
Vue.use(VeeValidate, { locale: 'validationDynamicLocale', inject: false, classes: true });

Vue.component('rental-listing', require('./components/RentalListing.vue'));
Vue.component('map-search', require('./components/MapSearch.vue'));
Vue.component('map-searches', require('./components/MapSearches.vue'));
Vue.component('favorites-counter', require('./components/FavoritesCounter.vue'));
Vue.component('tour', require('./components/Tour.vue'));
Vue.component('appointment-planner', require('./components/AppointmentPlanner.vue'));
Vue.component('matches-listing', require('./components/MatchesListing.vue'));
Vue.component('hamburger', require('vue-hamburger'));
Vue.component('message-form', require('./components/MessageForm.vue'));
Vue.component('v-members-tabs', require('./admin/components/VMembersTabs.vue'));
Vue.component('v-autocomplete', require('./admin/components/VAutocomplete.vue'));
Vue.component('v-form-list-replicator', require('./admin/components/VFormListReplicator.vue'));
Vue.component('v-textfield', require('./admin/components/VTextfield'));
Vue.component('v-checkboxes', require('./admin/components/VCheckboxes'));
Vue.component('v-radios', require('./admin/components/VRadios'));
Vue.component('v-select', require('./admin/components/VSelect'));
Vue.component('v-select-search', require('./admin/components/VSelectSearch'));
Vue.component('v-details-form', require('./admin/components/VDetailsForm'));
Vue.component('v-details-inner-form', require('./admin/components/VDetailsInnerForm.vue'));
Vue.component('v-textfield-public', require('./admin/components/VTextfieldPublic'));
Vue.component('v-checkboxes-public', require('./admin/components/VCheckboxesPublic'));
Vue.component('v-radios-public', require('./admin/components/VRadiosPublic'));
Vue.component('v-select-public', require('./admin/components/VSelectPublic.vue'));
Vue.component('v-datepicker-public', require('./admin/components/VDatepickerPublic'));
Vue.component('v-datepicker', require('./admin/components/VDatepicker'));
Vue.component('v-datepicker-visible', require('./admin/components/VDatepickerVisible.vue'));
Vue.component('v-subscribe-form', require('./admin/components/VSubscribeForm'));
Vue.component('v-subscribe-inner-form', require('./admin/components/VSubscribeInnerForm.vue'));
Vue.component('v-search-profile-form', require('./admin/components/VSearchProfileForm.vue'));
Vue.component('v-autocomplete-public', require('./admin/components/VAutocompletePublic.vue'));
Vue.component('v-autocomplete-custom', require('./admin/components/VAutocompleteCustom'));
Vue.component('v-form-public', require('./admin/components/VFormPublic'));
Vue.component('v-textarea-public', require('./admin/components/VTextareaPublic'));
Vue.component('v-contact-form', require('./admin/components/VContactForm'));
Vue.component('v-let-form', require('./admin/components/VLetForm'));
Vue.component('v-manage-form', require('./admin/components/VManageForm'));
Vue.component('v-let-sh-form', require('./admin/components/VLetShForm'));
Vue.component('v-gallery', require('./admin/components/VGallery'));
Vue.component('v-wysiwyg', require('./admin/components/VWysiwyg'));
Vue.component('v-tabs', require('./admin/components/VTabs'));
Vue.component('v-card', require('./admin/components/VCard'));
Vue.component('v-date-filter', require('./admin/components/VDateFilter'));
Vue.component('v-table-body', require('./admin/components/VTableBody'));
Vue.component('v-status-toggler', require('./admin/components/VStatusToggler'));
Vue.component('v-status-changer', require('./admin/components/VStatusChanger'));
Vue.component('v-date-filter-public', require('./admin/components/VDateFilterPublic'));
Vue.component('v-numeric-field-public', require('./admin/components/VNumericFieldPublic'));
Vue.component('v-signature', require('./admin/components/VSignature'));
Vue.component('video-player', require('./components/VideoPlayer.vue'));
Vue.component('v-gallery-inspections-public', require('./admin/components/VGalleryInspectionsPublic.vue'));
Vue.component('notifications-subscribe', require('./components/NotificationsSubscribe'));
Vue.component('booking-form', require('./components/BookingForm.vue'));

Vue.component('notifications-dropdown', require('./components/NotificationsDropdown'));
Vue.component('infinite-scroll', require('./components/InfiniteScroll.vue'));
Vue.component('login', require('./components/Login.vue'));
Vue.component('login-form', require('./components/LoginForm.vue'));
Vue.component('password-form', require('./components/PasswordForm.vue'));
Vue.component('main-search', require('./components/MainSearch.vue'));
Vue.component('work-flow', require('./components/WorkFlow.vue'));
Vue.component('faq', require('./components/FAQ.vue'));
Vue.component('signup', require('./components/Signup.vue'));
Vue.component('theme-input', require('./components/ThemeInput.vue'));
Vue.component('theme-checkboxes', require('./components/ThemeCheckboxes.vue'));
Vue.component('theme-filter-checkboxes', require('./components/ThemeFilterCheckboxes.vue'));
Vue.component('theme-radios', require('./components/ThemeRadios.vue'));
Vue.component('theme-calendar', require('./components/ThemeCalendar.vue'));
Vue.component('theme-toggler', require('./components/ThemeToggler.vue'));
Vue.component('theme-location-dropdown', require('./components/ThemeLocationDropdown.vue'));
Vue.component('theme-select', require('./components/ThemeSelect.vue'));
Vue.component('theme-numeric', require('./components/ThemeNumeric.vue'));
Vue.component('theme-autocomplete', require('./components/ThemeAutocomplete.vue'));
Vue.component('theme-autocomplete-custom', require('./components/ThemeAutocompleteCustom.vue'));
Vue.component('theme-textarea', require('./components/ThemeTextarea.vue'));
Vue.component('theme-file', require('./components/ThemeFile.vue'));
Vue.component('theme-download', require('./components/ThemeDownload.vue'));
Vue.component('theme-tour', require('./components/ThemeTour.vue'));
Vue.component('theme-districts-dropdown', require('./components/ThemeDistrictsDropdown.vue'));
Vue.component('theme-form-public', require('./components/ThemeFormPublic.vue'));
Vue.component('theme-notifications', require('./components/ThemeNotifications.vue'));
Vue.component('theme-wysiwyg', require('./components/ThemeWysiwyg.vue'));
Vue.component('theme-gallery', require('./components/ThemeGallery.vue'));
Vue.component('account-details-outer-form', require('./components/AccountDetailsOuterForm.vue'));
Vue.component('account-details-inner-form', require('./components/AccountDetailsInnerForm.vue'));
Vue.component('search-preferences-form', require('./components/SearchPreferencesForm.vue'));
Vue.component('search-preferences-form-sh', require('./components/SearchPreferencesFormSH.vue'));
Vue.component('registration-form', require('./components/RegistrationForm.vue'));
Vue.component('registration-inner-form', require('./components/RegistrationInnerForm.vue'));
Vue.component('registration-form-sh', require('./components/RegistrationFormSH.vue'));
Vue.component('rent-property-form', require('./components/RentPropertyForm.vue'));
Vue.component('breadcrumbs', require('./components/Breadcrumbs.vue'));
Vue.component('property-search-control', require('./components/PropertySearchControl.vue'));
Vue.component('active-profile-search-control', require('./components/ActiveProfileSearchControl.vue'));
Vue.component('properties-listing', require('./components/PropertiesListing.vue'));
Vue.component('properties-map', require('./components/PropertiesMap.vue'));
Vue.component('searches-map', require('./components/SearchesMap.vue'));
Vue.component('searchprofiles-listing', require('./components/SearchprofilesListing.vue'));
Vue.component('schedule-flow', require('./components/ScheduleFlow.vue'));
Vue.component('schedule-flow-login', require('./components/ScheduleFlowLogin.vue'));
Vue.component('schedule-flow-viewing', require('./components/ScheduleFlowViewing.vue'));
Vue.component('schedule-flow-confirmation', require('./components/ScheduleFlowConfirmation.vue'));
Vue.component('v-document-card', require('./components/VDocumentCard.vue'));
Vue.component('booking-widget', require('./components/BookingWidget.vue'));
Vue.component('message-widget', require('./components/MessageWidget.vue'));
Vue.component('v-tenant-form', require('./components/VTenantForm.vue'));
Vue.component('contact-form', require('./components/ContactForm.vue'));
Vue.component('v-recaptcha', require('./admin/components/VRecaptcha.vue'));
Vue.component('manage-bookings-catalog', require('./components/ManageBookingsCatalog.vue'));
Vue.component('my-bookings-catalog', require('./components/MyBookingsCatalog.vue'));
Vue.component('v-lightcase-holder', require('./admin/components/VLightcaseHolder'));
Vue.component('booking-details-document', require('./components/BookingDetailsDocument.vue'));
Vue.component('booking-details-dates-modal', require('./components/BookingDetailsDatesModal.vue'));
Vue.component('booking-details-guests-modal', require('./components/BookingDetailsGuestsModal.vue'));
Vue.component('theme-details-form', require('./components/ThemeDetailsForm.vue'));
Vue.component('theme-details-inner-form', require('./components/ThemeDetailsInnerForm.vue'));
Vue.component('favorites-listing', require('./components/FavoritesListing.vue'));
Vue.component('manage-properties-status', require('./components/ManagePropertiesStatus.vue'));
Vue.component('booking-details-landlord-document', require('./components/BookingDetailsDocumentLandlord.vue'));
Vue.component('independant-form', require('./components/IndependantForm.vue'));
Vue.component('dependant-form', require('./components/DependantForm.vue'));
Vue.component('theme-calendar-with-buttons', require('./components/ThemeCalendarWithButtons.vue'));
Vue.component('v-facility-form-public', require('./components/VFacilityFormPublic.vue'));
Vue.component('appointment-date-time-modal', require('./components/AppointmentDateTimeModal.vue'));
Vue.component('appointment-guests-modal', require('./components/AppointmentGuestsModal.vue'));
Vue.component('theme-multiple-files', require('./components/ThemeMultipleFiles.vue'));
Vue.component('rent-property-sh-form', require('./components/RentPropertyShForm.vue'));
Vue.component('theme-manage-form', require('./components/ThemeManageForm.vue'));
Vue.component('dependant-form-new', require('./components/DependantFormNew.vue'));
Vue.component('independant-form-new', require('./components/IndependantFormNew.vue'));
Vue.component('booking-form', require('./components/BookingForm.vue'));


Validator.extend('min.string', {
  getMessage: (field, [min]) => window.app.locales.validation.min.string.replace(":attribute", field).replace(":min", min),
  validate: (value, [min]) => {
    return value.length >= min;
  }
});

Validator.extend('min.numeric', {
  getMessage: (field, [min]) => window.app.locales.validation.min.numeric.replace(":attribute", field).replace(":min", min),
  validate: (value, [min]) => {
    return +value >= min;
  }
});

Validator.extend('min.array', {
  getMessage: (field, [min]) => window.app.locales.validation.min.array.replace(":attribute", field).replace(":min", min),
  validate: (value, [min]) => {
    return value.length >= min;
  }
});

Validator.extend('max.string', {
  getMessage: (field, [max]) => window.app.locales.validation.max.string.replace(":attribute", field).replace(":max", max),
  validate: (value, [max]) => {
    return value.length <= max;
  }
});

Validator.extend('max.numeric', {
  getMessage: (field, [max]) => window.app.locales.validation.max.numeric.replace(":attribute", field).replace(":max", max),
  validate: (value, [max]) => {
    return +value <= max;
  }
});

Validator.extend('max.array', {
  getMessage: (field, [max]) => window.app.locales.validation.max.array.replace(":attribute", field).replace(":max", max),
  validate: (value, [max]) => {
    return value.length <= max;
  }
});

Validator.extend('between.string', {
  getMessage: (field, [min, max]) => window.app.locales.validation.between.string.replace(":attribute", field).replace(":min", min).replace(":max", max),
  validate: (value, [min, max]) => {
    return max >= value.length >= min;
  }
});

Validator.extend('between.numeric', {
  getMessage: (field, [min, max]) => window.app.locales.validation.between.numeric.replace(":attribute", field).replace(":min", min).replace(":max", max),
  validate: (value, [min, max]) => {
    return max >= +value >= min;
  }
});

Validator.extend('between.array', {
  getMessage: (field, [min, max]) => window.app.locales.validation.between.array.replace(":attribute", field).replace(":min", min).replace(":max", max),
  validate: (value, [min, max]) => {
    return max >= value.length >= min;
  }
});

Validator.extend('size.string', {
  getMessage: (field, [size]) => window.app.locales.validation.size.string.replace(":attribute", field).replace(":size", size),
  validate: (value, [size]) => {
    return value.length == size;
  }
});

Validator.extend('size.numeric', {
  getMessage: (field, [size]) => window.app.locales.validation.size.numeric.replace(":attribute", field).replace(":size", size),
  validate: (value, [size]) => {
    return +value == size;
  }
});

Validator.extend('size.array', {
  getMessage: (field, [size]) => window.app.locales.validation.size.array.replace(":attribute", field).replace(":size", size),
  validate: (value, [size]) => {
    return value.length == size;
  }
});

Validator.extend('alpha_dash', {
  getMessage: field => window.app.locales.validation.alpha_dash.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9a-zA-Z _-]+$");
    return regex.test(value);
  }
});

Validator.extend('post_code', {
  getMessage: field => window.app.locales.validation.post_code.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[A-Z0-9][A-Z0-9\- ]{0,10}[A-Z0-9]$", 'i');
    return regex.test(value);
  }
});

Validator.extend('alpha_num_spaces', {
  getMessage: field => window.app.locales.validation.alpha_num_spaces.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9a-zA-Z -]+$");
    return regex.test(value);
  }
});

Validator.extend('alpha_spaces_dash', {
  getMessage: field => window.app.locales.validation.alpha_spaces_dash.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[a-zA-Z -]+$");
    return regex.test(value);
  }
});

Validator.extend('num_spaces', {
  getMessage: field => window.app.locales.validation.num_spaces.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9 ]+$");
    return regex.test(value);
  }
});

Validator.extend('make_choice', {
  getMessage: field => window.app.locales.validation.make_choice.replace(":attribute", field),
  validate: value => {
    if (typeof value !== "object") {
      var regex = new RegExp("^[0-9]+$");
      return regex.test(value);
    } else {
      var result = !!value.length;
      return result;
    }
  }
});

Validator.extend('location', {
  getMessage: field => window.app.locales.validation.location.replace(":attribute", field),
  validate: value => {
    var regex = /^[0-9]*$/;
    return regex.test(value);
  }
});

Validator.extend('locations', {
  getMessage: field => window.app.locales.validation.location.replace(":attribute", field),
  validate: value => {
    return Array.isArray(value) && value.length > 0;
  }
});

Validator.extend('attach_autocomplete', {
  getMessage: field => window.app.locales.validation.attach_autocomplete.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9]*$");
    return regex.test(value);
  }
});

Validator.extend('model_date', {
  getMessage: field => window.app.locales.validation.model_date.replace(":attribute", field),
  validate: value => {
    var regex = /^\s*(3[01]|[12][0-9]|0?[1-9])-(1[012]|0?[1-9])-((?:19|20)\d{2})\s*$/;
    return regex.test(value);
  }
});

Validator.extend('phone_number', {
  getMessage: field => window.app.locales.validation.phone_number.replace(":attribute", field),
  validate: value => {

    if (value.toString().length < 9) {
      return false;
    }
    var regex = /^\+?([0-9])+-?[0-9]((-[0-9]+)?)+\.?$/;
    return regex.test(value);
  }
});

Validator.extend('tel', {
  getMessage: field => window.app.locales.validation.tel.replace(":attribute", field),
  validate: value => {

    if (value.toString().length < 9) {
      return false;
    }
    var regex = /^\+?([0-9])+?[0-9](([0-9]+)?)$/;
    return regex.test(value);
  }
});

Validator.extend('fax_number', {
  getMessage: field => window.app.locales.validation.fax_number.replace(":attribute", field),
  validate: value => {

    if (value.toString().length < 10) {
      return false;
    }
    var regex = /^\+?([0-9])+-?[0-9]((-[0-9]+)?)+$/;
    return regex.test(value);
  }
});
let methods = {
  np: function (accessor, defaultValue) {
    try {
      return accessor()
    } catch (error) {
      if (error instanceof TypeError) {
        if (typeof defaultValue !== 'undefined') {
          return defaultValue;
        }
        return;
      }
      throw error
    }
  },
  getMetadata: function (key) {
    let filtered = this.metadata.filter(index => index.key === key)
    return _.zipObject(filtered.map(item => item.id), filtered.map(item => item.value))
  },
  validate: function (event, scope = null) {
    this.$validator.validateAll(scope).then((result) => {
      if (result) {
        return;
      }
      this.$emit('validation-error', this.$validator.errors);
      event.preventDefault();
      sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
    });
  },
  sendForm: function (form, scope, redirect) {
    if (scope) {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll(scope).then(isValid => {
          if (isValid) {
            let postData = $(form).serializeArray();
            let action = form.action;
            $.ajax({
              url: action,
              type: "POST",
              data: postData,
              cache: false,
              success: function (data) {
                resolve(data);
              },
              error: function () {
                reject('Couldn\'t save changes');
              }
            });
          } else {
            this.$emit('validation-error', this.$validator.errors);
            reject('The form contain errors.' + '\n' + this.$validator.errors.items[0].msg);
          }
        }, error => {
          reject('The form contain errors!');
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            let postData = $(form).serializeArray();
            if (redirect) {
              postData.push({ name: 'submit', value: 'save_and_redirect' });
              postData.push({ name: 'qp', value: "" + window.location.search.substring(1) });
            }
            let action = form.action;
            $.ajax({
              url: action,
              type: "POST",
              data: postData,
              cache: false,
              success: function (data) {
                resolve(data);
              },
              error: function () {
                reject('Couldn\'t save changes');
              }
            });
          } else {
            this.$emit('validation-error', this.$validator.errors);
            reject('The form contain errors.' + '\n' + this.$validator.errors.items[0].msg);
          }
        }, error => {
          reject('The form contain errors!');
        });
      });
    }

  },

  saveAndShowAlert: function (event, scope) {
    event.preventDefault();

    $('.edit-facility').each(function () {
      if (!$(this).parent().is(":hidden")) {
        $(this).find('[type="submit"]').first().click();
      }
    });
    this.sendForm(event.target, scope).then(response => {
      this.shouldReloadOnCloseModal = true;
      this.$emit('saveAndShowFinished', response);
      sweetalert('Success', 'The data has been updated!', 'success').then(value => {
        if (response.redirect) {
          window.location.href = response.redirect;
        }
      });
    }, err => {
      sweetalert('Opps!', err, 'error');
    })
  },

  saveBookingAndShowConfirmAlert: function (event, scope, confirmationText, redirect) {
    event.preventDefault();
    let that = this;
    this.$validator.validateAll(scope).then((isValid) => {
      if (isValid) {
        that.$root.$emit("uploading-started");
        var form = $('#' + scope);

        let uploadTarget = $(form).find('input[type="file"]');
        var data = new FormData();
        let postData = form.serializeArray();
        const submitButtons = document.querySelectorAll('[data-type="submitBtn"]');

        for (let i = 0; i < postData.length; i++) {
          data.append(postData[i].name, postData[i].value);
        }
        if (uploadTarget.length) {
          for (let i = 0; i < uploadTarget.length; i++) {
            if (uploadTarget[i].files.length) {
              for (let j = 0; j < uploadTarget[i].files.length; j++) {
                if (window.FileReader) {
                  let reader = new FileReader();
                  reader.readAsDataURL(uploadTarget[i].files[j]);
                }
                data.append(`document[${j}]`, uploadTarget[i].files[j]);
              }
            }
          }
        }

        submitButtons.forEach((button) => button.classList.add("disabled-state"));

        $.ajax({
          url: form.attr("action"),
          method: "post",
          data: data,
          enctype: "multipart/form-data",
          processData: false,
          contentType: false,
          cache: false,
          xhr: function() {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener("progress", function(evt) {
                if (evt.lengthComputable) {
                    var percentComplete = ((evt.loaded / evt.total) * 100);
                    $(".progress-bar").width(parseInt(percentComplete) + '%');
                    $(".progress-bar").html(parseInt(percentComplete)+'%');
                }
            }, false);
            return xhr;
          },
          success: function (result, textStatus, xhr) {
            document.querySelector(".js-loader-item").style.display = "none";
            that.$root.$emit("uploading-completed");

            if (result.error) {
              var err =
                result.error !== ""
                  ? result.error
                  : window.app.locales.common.error;
              sweetalert(window.app.locales.common.error, err, "error");
            } else {
              sweetalert(confirmationText, {
                buttons: [
                  window.app.locales.common && window.app.locales.common.stay_on_page,
                  window.app.locales.common && window.app.locales.common.go_to_my_bookings,
                ],
                dangerMode: true,
              }).then(value => {
                if (value) {
                  window.location.href = redirect;
                } else {
                  for (var i = 0; i < result.disabledDates.length; i++) {
                    window.app.disabledDates.push(result.disabledDates[i]);
                  }
                }
              });
            }

            if (scope == 'booking-widget-form') {
              window.app.$refs.booking_widget_form.clearForm();
            } else {
              window.app.$refs.booking_widget_form_m.clearForm();
            }

            submitButtons.forEach((button) => button.classList.remove("disabled-state"));
          },
          error: function (result) {
            document.querySelector(".js-loader-item").style.display = "none";
            this.$root.$emit("uploading-completed");
            sweetalert(
              window.app.locales.common.error,
              window.app.locales.common.error,
              "error"
            );
            submitButtons.forEach((button) => button.classList.remove("disabled-state"));
          },
        });
      } else {
        sweetalert(
          window.app.locales.common.error,
          window.app.locales.subscriptions.form_with_errors,
          "error"
        );
      }
    });
  },

  saveAndRedirect: function (event, scope) {
    event.preventDefault();
    $('.edit-facility').each(function () {
      if (!$(this).parent().is(":hidden")) {
        $(this).find('[type="submit"]').first().click();
      }
    });
    let form = $('body').find('#' + scope);
    if (form.length) {
      this.sendForm(form[0], null, true).then(response => {
        this.shouldReloadOnCloseModal = true;
        sweetalert('Success', 'The data has been updated!', 'success').then(value => {
          window.location.href = response;
        });
      });
    }
  },
  logout() {
    this.$store.dispatch('authLogout').then(() => { });
  },
  toggleProfileNav(e) {
    var opener = this.$refs.profileNavOpener;
    var openerMobile = this.$refs.profileNavOpenerMobile;
    var nav = this.$refs.profileNav;
    var target = e.target;

    if (opener) {
      if (opener === target || opener.contains(target)) {
        this.profileNavState = !this.profileNavState;
      } else if (openerMobile === target || openerMobile.contains(target)) {
        this.profileNavState = !this.profileNavState;
      } else if (nav !== target && !nav.contains(target)) {
        this.profileNavState = false;
      }
    }
  },
  // toggleLangSelector() {
  //   this.$store.commit('TOGGLE_LANG_MENU');
  // },
  scrollToCardPublic: function (event) {
    let body = $('html, body');
    let link = event.target;
    let links = document.querySelectorAll('.nav-link');

    [...links].forEach(function (item) {
      item.classList.remove('current');
    });

    if (link.classList) {
      link.classList.add('current');
    }

    let navbarHeight = link.closest('.navbar.sticky').clientHeight;
    let arr = link.getAttribute('data-id').split('_');
    let target = arr[0] + arr[1];
    let duration = 700;
    if ($(window).width() < 767) {
      body.animate({
        scrollTop: $(target).offset().top,
      }, duration);
    } else {
      body.animate({
        scrollTop: $(target).offset().top - navbarHeight,
      }, duration);
    }
  },
  emitEvent(event) {
    this.$emit(event);
  },
  isTouchDevice: function () {
    if ('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch) {
      document.getElementById('page-top').classList.add('touch-device');

      return true;
    }
  },
  resetLoginModal() {
    this.$refs['login_modal_element'].backToLogin();
  },
  toggleUserMenu() {
    this.userMenu = !this.userMenu;
    if (this.userMenu) {
      document.addEventListener('click', this.handleUserMenuClickOutside, true);
    } else {
      document.removeEventListener('click', this.handleUserMenuClickOutside, true);
    }
  },
  handleUserMenuClickOutside(event) {
    if (this.$refs.userBtnRef && this.$refs.userBtnRef.contains(event.target)) return;
    if (!this.$refs.userMenuRef.contains(event.target)) {
      this.userMenu = false;
      document.removeEventListener('click', this.handleUserMenuClickOutside, true);
    }
  }
};

window.app = _.merge(window.app, {
  el: '#page',
  store,
  computed: {
    ...mapGetters(['locale', 'locales', 'metadata']),
    error() {
      return this.$store.getters.getAuthError;
    },
    user() {
      return this.$store.getters.getAuthUser;
    },
    page() {
      return this.$store.getters.getPropertiesPage;
    },
    profileToggleClass() {
      return { 'profile-nav_active': this.profileNavState };
    }
  },
  methods: {
    ...mapActions(['fetchAppMetadata', 'fetchAppLocales']),
    ...methods
  },
  data: Object.assign({
    name: 'AtHome',
    isMapRendered: false,
    isDetailMapRendered: false,
    searchesMap: false,
    shouldReloadOnCloseModal: false,
    availableLocales: [
      {
        code: 'en',
        name: 'English'
      },
      {
        code: 'nl',
        name: 'Dutch'
      }
    ],
    grid: false,
    ready: false,
    navigationOpen: false,
    profileNavState: false,
    userMenu: false
  }, window.methods ? window.methods : {}),
  created() {
    this.fetchAppMetadata();
    this.fetchAppLocales();
    this.ready = true;
    document.addEventListener('click', this.toggleProfileNav);
  },
  destroyed() {
    document.removeEventListener('click', this.toggleProfileNav);
  },
});
window.app = new Vue(window.app);

let boundMethods = {};
for (let methodName in methods) {
  boundMethods[methodName] = methods[methodName].bind(window.app);
}

window.app.methods = boundMethods;
window.app.sweetalert = sweetalert;
import Siema from 'siema';

_.each(document.querySelectorAll('.siema'), (item) => {
  let bullets = [];
  if (document.querySelectorAll('.siema__slide').length) {
    let siema = new Siema({
      selector: item.querySelector('.siema__slides'),
      duration: 200,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      threshold: 20,
      onInit() {
        bullets = item.querySelector('.siema__bullets');

        bullets.children[this.currentSlide].classList.add('siema__bullet--is-active');

        _.each(bullets.children, (bullet, index) => {
          bullet.addEventListener('click', (event) => {
            this.goTo(index);
          });
        });

        let node;

        node = document.querySelector('.siema__arrow--prev');
        if (node) {
          node.addEventListener('click', () => {
            this.prev();
          });
        }

        node = document.querySelector('.siema__arrow--next');
        if (node) {
          node.addEventListener('click', () => {
            this.next();
          });
        }

        document.getElementById("slidesHolder").oncontextmenu = function () {
          return false;
        };

      },
      onChange() {
        _.each(bullets.children, (item) => {
          item.classList.remove('siema__bullet--is-active');
        });

        bullets.children[this.currentSlide].classList.add('siema__bullet--is-active');
      },
    });
  }
});

import Velocity from 'velocity-animate';
import Echo from 'laravel-echo';
import Vue from 'vue';

document.querySelector('body').addEventListener('click', (event) => {
  if (
      !event.target.classList.contains('swal-overlay') &&
        (
          !document.querySelector('.swal-overlay') ||
          document.querySelector('.swal-overlay') && !document.querySelector('.swal-overlay').contains(event.target)
        )
  ) {
    let modals = document.querySelectorAll('[data-feature=\'modal\']:not([class="modal modal-code"])');
    let page = document.getElementById('page');

    var modal = event.target;
    if($(modal).data('bs.modal')){
      Velocity(modal, {
        opacity: 0,
      }, { display: 'none' });
      $(modal).modal('hide');
      if($(modal).data('name') == 'confirm'){
        var searchUrl = location.search;
        var urlValue = document.location.href;
        if(searchUrl.includes('action=')){
          if(searchUrl.includes('vip=1')){
              urlValue = urlValue.replace(searchUrl, '?vip=1');
          }else{
              urlValue = urlValue.replace(searchUrl, '');
          }
          window.location.href = urlValue;
        }
      }
    }
   var count=0;
    _.each(modals, (modal) => {
      if($(modal).data('bs.modal') && $(modal).data('bs.modal').isShown){
       count++;
      }
    });
    if(count == 0){
      page.classList.remove("z-index");
    }
  }
});

// init modals
document.addEventListener('click', function (event) {
  let modalTrigger = event.target.closest('[data-feature="open-modal"]');
  if (!modalTrigger) return;

  event.stopPropagation();

  let modal = document.querySelector(`[data-feature="modal"][data-name="${modalTrigger.dataset.target}"]`);
  let page = document.getElementById('page');
  page.classList.add("z-index");

  Velocity(modal, { opacity: 1 }, { display: 'flex' });
  $(modal).modal('show');
});

document.addEventListener('click', function (event) {
  let modalCloseTrigger = event.target.closest('[data-feature="close-modal"]');
  if (!modalCloseTrigger) return;

  event.stopPropagation();

  let modal = document.querySelector(`[data-feature="modal"][data-name="${modalCloseTrigger.dataset.target}"]`);
  let page = document.getElementById('page');
  page.classList.remove("z-index");

  Velocity(modal, { opacity: 0 }, { display: 'none' });
  $(modal).modal('hide');
});

document.addEventListener('click', (event) => {
  let modalContent = event.target.closest('[data-feature="modal-active-area"]');
  if (!modalContent) return;

  event.stopPropagation();
});

let tabsCollection = document.querySelectorAll('[data-feature=\'tabs\']');

_.each(tabsCollection, (tabs) => {
  _.each(tabs.children, (tab) => {
    if (!tab.classList.contains(tabs.dataset.activeItemClass) && tab.dataset.target) {
      document.querySelector('[data-name=\'' + tab.dataset.target + '\']').style.display = 'none';
    }

    tab.addEventListener('click', function (event) {
      _.each(tabs.children, (tab) => {
        tab.classList.remove(tabs.dataset.activeItemClass);

        if (tab.dataset.target) {
          Velocity(document.querySelector('[data-name=\'' + tab.dataset.target + '\']'), {
            opacity: 0,
          }, { display: 'none' });
        }
      });

      this.classList.add(tabs.dataset.activeItemClass);

      if (this.dataset.target) {
        Velocity(document.querySelector('[data-name=\'' + this.dataset.target + '\']'), {
          opacity: 1,
        }, { display: 'block' });
      }
    });
  });
});

function disableCopyContent(selector) {
  [...document.querySelectorAll(selector)].forEach(function (el) {
    el.oncontextmenu = function () {
      return false;
    };
  });
}

function createDpiTestElements() {
  var getDpiHtmlStyle = 'data-dpi-test { height: 1in; left: -100%; position: absolute; top: -100%; width: 1in; }'

  var head = document.getElementsByTagName('head')[0]
  var getDPIElement = document.createElement('style')
  getDPIElement.setAttribute('type', 'text/css')
  getDPIElement.setAttribute('rel', 'stylesheet')
  getDPIElement.innerHTML = getDpiHtmlStyle
  head.appendChild(getDPIElement)

  var body = document.getElementsByTagName('body')[0]
  var dpiTestElement = document.createElement('data-dpi-test')
  dpiTestElement.setAttribute('id', 'dpi-test')
  body.appendChild(dpiTestElement)
}

function setActiveLink() {
  let body = $('html, body');
  let cards = body.find('.v-card');
  let links = body.find('.navbar.sticky a.nav-link');
  let cardsList = [];
  for (var i = 0; i < cards.length; i++) {
    let id = $(cards[i]).find('.v-card__vertical-position').attr('id');
    cardsList.push(id);
  }
  cardsList = cardsList.filter(Boolean); // prevent empty string in array

  function setActiveLinkOnScroll() {
    if (cardsList.length === 0) return;

    let firstCardPos = $('#' + cardsList[0]).offset().top + 1;
    let scrollTop = $(window).scrollTop() + 140;
    let scrollPos = firstCardPos > scrollTop ? firstCardPos : scrollTop;
    for (var i = 0; i < cardsList.length; i++) {
      if (cardsList.length == i + 1
        || $('#' + cardsList[i]).offset().top < scrollPos
        && $('#' + cardsList[i + 1]).offset().top >= scrollPos) {
        let current = links.filter('[href="#_' + cardsList[i] + '"]');
        links.removeClass('current');
        return current.addClass('current');
      }
    }
  }
  $(window).on('scroll', function () {
    setActiveLinkOnScroll();
  })
}

function toggleNav() {
  let navigation = document.querySelector('.func-navbar-nav');
  navigation.classList.toggle('opened');
}

function checkIfPCVersionEnabled() {
  //Detect if PC version is enabled in mobile browser
  if (window.outerWidth <= 767 && window.screen.width < window.innerWidth) {
    document.querySelector('body').classList.add('pc-version-is-enabled');
  }
}

$(document).ready(function () {


  setActiveLink();

  disableCopyContent('.func-properties-photo');

  checkIfPCVersionEnabled();

  if ($('.sticky').length) {
    var h = $('.sticky').first().offset().top,
      items = document.querySelectorAll('.nav-link');

    // sticky navbar
    $(window).scroll(function () {
      publicScrollHandler();
    });

    function publicScrollHandler() {
      if (window.pageYOffset >= h) {
        $('.sticky').first().addClass('navbar-fixed');
        $('.func-nav-bar-stub').outerHeight($('.sticky').outerHeight(true));
        if ($('.sticky').length) {
          $('body').addClass('navbar-fixed--padding');
        }
      } else {
        $('.sticky').first().removeClass('navbar-fixed');
        $('.func-nav-bar-stub').removeAttr('style');
        $('body').removeClass('navbar-fixed--padding');
      }
    }

    if (location.hash) {
      [...items].forEach(function (item) {
        if (item.attributes.href.value == location.hash) {
          if (item.classList) {
            item.classList.add('current');
            return;
          }
        }
      });
    }
  }

  if (window.innerWidth < 767) {
    let element = document.querySelector('.func-nav-link');

    if (typeof (element) != 'undefined' && element != null) {
      element.addEventListener('click', toggleNav)
    }
  }

  // let $scrollTopBtn = $('.func-scroll-to-top-btn');
  //
  // $(window).scroll(function () {
  //   if ($(this).scrollTop() >= 200) {
  //     $scrollTopBtn.fadeIn();
  //   } else {
  //     $scrollTopBtn.fadeOut();
  //   }
  // });
  //
  // $(document).on('click', '.func-scroll-to-top-btn', function () {
  //   $('body,html').animate({
  //     scrollTop: 0
  //   }, 700);
  // });
});

document.addEventListener("DOMContentLoaded", () => {
  window.onload = () => {
    const loader = document.getElementById('js-page-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  };
});


// WEBPACK FOOTER //
// ./resources/js/app.js